export default __webpack_public_path__ + "static/media/cockpit-Header-2k.eaffef5c.jpg";